import { render, staticRenderFns } from "./treePopupQuestion.vue?vue&type=template&id=50739a38&scoped=true"
import script from "./treePopupQuestion.vue?vue&type=script&lang=js"
export * from "./treePopupQuestion.vue?vue&type=script&lang=js"
import style0 from "./treePopupQuestion.vue?vue&type=style&index=0&id=50739a38&prod&lang=less&scoped=true"
import style1 from "./treePopupQuestion.vue?vue&type=style&index=1&id=50739a38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50739a38",
  null
  
)

export default component.exports